// Статьи блога SEO-пакета. Порядок в массиве = порядок в списке /blog.
// Один файл — одна статья, тексты лежат рядом с этим индексом.

import priznakiNeestestvennogoTrafika from "./priznakiNeestestvennogoTrafika";
import zashchitaOtNakrutkiKonkurentami from "./zashchitaOtNakrutkiKonkurentami";
import testirovshchikiIliTehnicheskieAgenty from "./testirovshchikiIliTehnicheskieAgenty";
import kakPopastVMoyuVolnu from "./kakPopastVMoyuVolnu";
import presaveKakNastroit from "./presaveKakNastroit";
import kalendarReliza from "./kalendarReliza";
import pravilaDistributorov from "./pravilaDistributorov";

const seoArticles = [
  priznakiNeestestvennogoTrafika,
  zashchitaOtNakrutkiKonkurentami,
  testirovshchikiIliTehnicheskieAgenty,
  kakPopastVMoyuVolnu,
  presaveKakNastroit,
  kalendarReliza,
  pravilaDistributorov,
];

export default seoArticles;
